"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "mirabella-eclano": {
    "2f4062cb": [{
      "hkey": "5eee6192",
      "slug": "passo-di-mirabella-pianopantano",
      "name": "Passo di Mirabella-Pianopantano",
      "primary": true,
      "skipSearch": false
    }],
    "passo": [{
      "hkey": "5eee6192",
      "slug": "passo-di-mirabella-pianopantano",
      "name": "Passo di Mirabella-Pianopantano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "192d1bf2": [{
      "hkey": "5eee6192",
      "slug": "passo-di-mirabella-pianopantano",
      "name": "Passo di Mirabella-Pianopantano",
      "primary": true,
      "skipSearch": false
    }],
    "pianopantano": [{
      "hkey": "5eee6192",
      "slug": "passo-di-mirabella-pianopantano",
      "name": "Passo di Mirabella-Pianopantano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "mirabella-eclano"
    }]
  }
};
exports["default"] = _default;